export default "__VITE_ASSET__BkhUG2PD__"